import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-listing-layout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './listing-layout.component.html',
  styleUrls: ['./listing-layout.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingLayoutComponent {
  @Input() filterPosition: 'left' | 'top' = 'left';
  @Input() showFilterPanel = true;
}
